<div class="ClsTransactionOTPModel p-0 ModalNPS" appDisabledRightClick>
  <div class="modal-dialog">
    <div class="modal-content AlertModalContentCls MainBgOtp">
      <div class="modal-body p-0">
        <div class="MainBg">
          <div class="MainInnerFormWithoutFlex" style="background-color: transparent;">
            <div class="OTPOuter BoxShadow text-center">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseMainModal()">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="head">Mode of payment</div>
              <div class="text-left">
                <div id="accordion" class="accordion">
                  <div id="AutoPayMain" *ngIf="isShowAutoPay" style="display:none" class="card accordion mb-0" #AutoPayMain>
                    <!--[ngClass]="{ 'disabled': selectedPaymentMethod !== '' && selectedPaymentMethod !=='AutoPay'}"-->
                    <div id="AutoPay" class="card-header collapsed pointer" data-toggle="collapse"
                      (click)="SetSelectedPaymentMode('AutoPay')">
                      <a class="card-title Mode-title">
                        <div class="Mode_Grid">
                          <img src="../../../assets/images/IIFL_New_Icons/Payment_1.svg" alt="">
                          <div class="T">
                            <div class="H">AutoPay</div>
                            <div class="D">One click payment using existing mandate</div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div id="collapseOne" class="card-body Mode collapse" data-parent="#accordion" #collapseOne>
                      <!-- <p class="Mode-para">Mandate 1</p>
                                    <p class="Mode-para">Mandate 2</p>
                                    <p class="Mode-para">Mandate 3</p> -->
                      <div class="row align-items-center">
                        <div class="col-md-8 col-sm-6 col-xs-12 InputBoxOuter pt-4">
                          <div class="has-float-label">
                            <select class="form-control CommonSelectBox TbxMarginBtm CustomSelectMandateCode">
                              <option value="" disabled='true'>Select mandate code</option>
                              <option *ngFor="let m of ClientMandateList" [value]="m.ResponseMandateId">
                                {{m.ShowMandate}}</option>
                            </select>
                            <label>Select mandate code</label>
                            <!-- [ngClass]="{ 'is-invalid': sipFormSubmitted && s.MandateCode.errors }"<div *ngIf="sipFormSubmitted && s.MandateCode.errors" class="invalid-feedback">
                                            <div *ngIf="s.MandateCode.errors.required">Please select mandate code</div>
                                          </div> -->
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter pt-3 Mob_paybutton">
                          <button [disabled]="AutoPayDisable" type="button" class="paybutton"
                            (click)="ProceedAutoPay()">Pay</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="RazorPayMain" class="card accordion mb-0" #RazorPayMain>
                    <!--[ngClass]="{ 'disabled': selectedPaymentMethod !=='' && selectedPaymentMethod !=='PaymentGateway'}"-->
                    <div id="PaymentGateway" class="card-header collapsed pointer" data-toggle="collapse"
                      data-parent="#accordion" (click)="SetSelectedPaymentMode('PaymentGateway')">
                      <a class="card-title Mode-title">
                        <div class="Mode_Grid">
                          <img src="../../../assets/images/IIFL_New_Icons/Payment_3.svg" alt="">
                          <div class="T">
                            <div class="H">Netbanking</div>
                            <div class="D">Pay via Netbanking | Powered by BSE</div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div id="collapseThree" class="card-body Mode collapse" data-parent="#accordion" #collapseThree>
                      <!-- <p class="Mode-para">Click here, pay from Razor Pay</p> -->
                      <!-- <p class="Mode-para">Mandate 2</p>
                      <p class="Mode-para">Mandate 3</p> -->
                      <div class="row align-items-center">
                        <div class="col-md-8 col-sm-6 col-xs-12 InputBoxOuter pt-4">
                          <div class="has-float-label">
                            <select class="form-control CommonSelectBox TbxMarginBtm CustomSelectBank">
                              <option value="" disabled='true'>Select Bank Account</option>
                              <option *ngFor="let m of BankList" [value]="m.TEXTFIELD">
                                {{m.TEXTFIELD}}</option>
                            </select>
                            <label>Select Bank Account</label>
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter pt-3 Mob_paybutton">
                          <button [disabled]="disablePaymentgateway" type="button" id="rzp-button1" class="paybutton"
                            (click)="ProceedPaymentGateway()">Pay</button>
                        </div>
                        <!-- <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter pt-4">
                          <button type="button" class="paybutton text-center" (click)="openwindowrazorpay()">Open</button>
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div id="UPIPayMain" class="card accordion mb-0" #UPIPayMain>
                    <!--[ngClass]="{ 'disabled': selectedPaymentMethod !=='' && selectedPaymentMethod !=='PaymentGateway'}"-->
                    <div id="UPI" class="card-header collapsed pointer" data-toggle="collapse" data-parent="#accordion"
                      (click)="SetSelectedPaymentMode('UPI')">
                      <a class="card-title Mode-title">
                        <div class="Mode_Grid">
                          <img src="../../../assets/images/IIFL_New_Icons/Payment_3.svg" alt="">
                          <div class="T">
                            <div class="H">UPI</div>
                            <div class="D">Pay via UPI | Powered by BSE</div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div id="collapseUPI" class="card-body Mode collapse" data-parent="#accordion" #collapseUPI>
                      <!-- <p class="Mode-para">Click here, pay from Razor Pay</p> -->
                      <!-- <p class="Mode-para">Mandate 2</p>
                      <p class="Mode-para">Mandate 3</p> -->
                        <form autocomplete="off" [formGroup]="UPIForm"> 
                      <div class="row align-items-center">
                      
                        <div class="col-md-8 col-sm-6 col-xs-12 InputBoxOuter pt-4">
                          <div class="has-float-label">
                            <select id="Bank" formControlName="Bank"
                              class="form-control CommonSelectBox TbxMarginBtm CustomSelectBank_UPI">
                              <option value="" disabled='true'>Select Bank Account</option>
                              <option *ngFor="let m of BankList" [value]="m.TEXTFIELD">
                                {{m.TEXTFIELD}}</option>
                            </select>
                            <label>Select Bank Account</label>
                            <div *ngIf="UPIFormSubmitted && u.Bank.errors" class="invalid-feedback">
                              <div *ngIf="u.Bank.errors.required">
                                Bank is required.
                              </div>
                            </div>
                          </div>
                        </div>
                       
                        </div>
                        <div class="row align-items-center">
                         <div class="col-md-8 col-sm-6 col-xs-12 InputBoxOuter pt-4">
                          <div class="has-float-label">
                            <input type="text" id="UPIID" formControlName="UPIID"
                              (change)="ValidateUPIID($event.target.value)"
                              [ngClass]="{ 'is-invalid': (UPIFormSubmitted)  && u.UPIID.errors }"
                              class="form-control CommonTextBox TbxMarginBtm" placeholder="&nbsp;" />
                            <label for="UPI">UPI ID</label>
                            <div *ngIf="UPIFormSubmitted && u.UPIID.errors" class="invalid-feedback">
                              <div *ngIf="u.UPIID.errors.required">UPI ID is required</div>
                              <div *ngIf="u.UPIID.errors.invalidUPI">UPI ID is invalid</div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter pt-3 Mob_paybutton">
                          <button [disabled]="disablePaymentgateway" type="button" id="rzp-button1" class="paybutton"
                            (click)="ProceedPaymentGateway()">Pay</button>
                        </div>
                        </div>
                        <!-- <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter pt-4">
                          <button type="button" class="paybutton text-center" (click)="openwindowrazorpay()">Open</button>
                        </div> --> 
                      
                      
                     </form>
                    </div>
                  </div>
                  <div id="NEFTRTGSMain" class="card accordion mb-0" #NEFTRTGSMain>
                    <!--[ngClass]="{ 'disabled': selectedPaymentMethod !== '' && selectedPaymentMethod !=='NEFT/RTGS'}" -->
                    <div id="NEFT/RTGS" class="card-header collapsed pointer" data-toggle="collapse"
                      data-parent="#accordion" (click)="SetSelectedPaymentMode('NEFT/RTGS')">
                      <a class="card-title Mode-title">
                        <div class="Mode_Grid">
                          <img src="../../../assets/images/IIFL_New_Icons/Payment_2.svg" alt="">
                          <div class="T">
                            <div class="H">NEFT/RTGS</div>
                            <div class="D">It will take upto 1 hr to reflect your money</div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div id="collapseTwo" class="card-body Mode collapse card-body-scroll" data-parent="#accordion"
                      #collapseTwo>
                      <!-- <p class="Mode-para">Mandate 1</p>
                      <p class="Mode-para">Mandate 2</p>
                      <p class="Mode-para">Mandate 3</p>  [ngClass]="{ 'is-invalid': sipFormSubmitted && s.SIPEndDate.errors }"-->

                      <form autocomplete="off" [formGroup]="NEFTRTGSForm">
                        <div class="row"
                          [ngClass]="ShowSuccessNEFTDetails || IsShowSuccessAndFail ? 'd-block' : 'd-none'">
                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="">
                              <h5>Successful Order</h5>
                            </div>
                            <p>
                              Your order has been successfully placed. Initiate an
                              <strong>NEFT</strong> or <strong>RTGS</strong> fund transfer from your
                              bank account to the exchange bank account provided below within one
                              working day.
                            </p>
                            <div class="details">
                              <p><strong>Bank Name: </strong><span id="copyableBankName" class="copyable-text">HDFC Bank
                                </span> <i class="fa fa-copy" (click)="copyFromText($event,'copyableBankName')"></i></p>
                              <p><strong>Account number: </strong> <span
                                  id="copyableAccountNo">{{ICCLAccountNo}}{{UCCCode}} </span> <i class="fa fa-copy"
                                  (click)="copyFromText($event,'copyableAccountNo')"></i></p>
                              <p><strong>IFSC Code: </strong> <span id="copyableIFSC">HDFC0000060 </span> <i
                                  class="fa fa-copy" (click)="copyFromText($event,'copyableIFSC')"></i></p>
                              <p><strong>Beneficiary name: </strong> <span id="copyableBeneficiaryName">INDIAN CLEARING
                                  CORPORATION LIMITED </span> <i class="fa fa-copy"
                                  (click)="copyFromText($event,'copyableBeneficiaryName')"></i></p>
                              <p><strong>Amount: </strong> ₹<span id="copyableAmount">{{Amount}} </span> <i
                                  class="fa fa-copy" (click)="copyFromText($event,'copyableAmount')"></i></p>
                              <p><strong>Account Type: </strong> Current</p>
                              <p><strong>Payment mode: </strong> NEFT or RTGS</p>
                            </div>
                            <p>
                              <strong>IMPS</strong> fund transfers are <strong>not</strong> permitted and will fail.
                              Ensure that the transfer is made from a bank account linked with Incred Markets for
                              successful processing.
                            </p>
                          </div>
                        </div>
                        <div class="row"
                          [ngClass]="(!ShowSuccessNEFTDetails || IsShowSuccessAndFail) && !NonFOTFlag  ? 'd-block' : 'd-none'">
                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="">
                              <h5>Failed Order</h5>
                            </div>
                            <p>
                              Your order placement has been failed.
                            </p>
                            <div id="NEFTFailureReason" class="details">
                              <p><strong>Reason:</strong> {{FailureReason}}</p>
                            </div>
                          </div>
                        </div>

                        <div class="row" [ngClass]="NonFOTFlag ? 'd-block' : 'd-none'">
                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="">
                              <h5>Successful Order</h5>
                            </div>
                            <p>
                              Your SIP has been Registered Successfully.
                            </p>
                            <div class="details">
                              <p><strong>Order Number: </strong> {{SuccessReason}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="row StickyBtm">
                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <button type="button" class="CommonSubmitButton CustomSubmit"
                              (click)="goToDashboard()">Okay</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div id="ChequeMode" class="card accordion mb-0"
                    *ngIf="G_UccCode == 'MISHTI1' || G_UccCode == '42791716' || G_UccCode == '37297489' || G_UccCode == 'GUPT7677' || SBCodeForChallan == 'MF14027' || SBCodeForChallan == 'S0014' || G_UccCode == 'HARSSHAI'"
                    #ChequeMode>
                    <!--[ngClass]="{ 'disabled': selectedPaymentMethod !== '' && selectedPaymentMethod !=='NEFT/RTGS'}" -->
                    <div id="ChequeMode" class="card-header collapsed pointer" data-toggle="collapse"
                      data-parent="#accordion" (click)="SetSelectedPaymentMode('CHEQUEMODE')">
                      <a class="card-title Mode-title">
                        <div class="Mode_Grid">
                          <img src="../../../assets/images/IIFL_New_Icons/Payment_2.svg" alt="">
                          <div class="T">
                            <div class="H">Cheque Payment</div>
                            <!-- <div class="D">It will take upto 1 hr to reflect your money</div> -->
                          </div>
                          <!-- <img src="../../../assets/images/IIFL_New_Icons/accordion-down-arrow_Payment.svg" alt="Toggle Arrow"
                          style="width: 15.5px; height: 15.5px; position: relative; right: 0px;" /> -->
                        </div>
                      </a>
                    </div>
                    <!-- <img src="../../../assets/images/accordion-down-arrow_Payment.svg" 
                    class="showToggleArrow" (click)="SetSelectedPaymentMode('CHEQUEMODE')" style="position: absolute;
                                        right: 22px; top: 22px;"/> -->
                    <div id="collapseseven" class="card-body Mode collapse" data-parent="#accordion" #collapseseven>
                      <!-- <p class="Mode-para">Click here, pay from Razor Pay</p> -->
                      <!-- <p class="Mode-para">Mandate 2</p>
                      <p class="Mode-para">Mandate 3</p> -->
                      <form autocomplete="off" [formGroup]="ChequeForm">
                        <div class="row">
                          <div class="col-md-8 col-sm-6 col-xs-12 InputBoxOuter pt-4">
                            <div class="has-float-label">
                              <select class="form-control CommonSelectBox TbxMarginBtm CustomSelectChequeBank">
                                <option value="" disabled selected>Select Bank Account</option>
                                <option *ngFor="let m of BankListCheque" [value]="m.TEXTFIELD">
                                  {{m.TEXTFIELD}}</option>
                              </select>
                              <label>Select Bank Account</label>
                              <div class="invalidBank" *ngIf="showChequeBankError">Kindly select a bank Account</div>
                            </div>
                            <div class="has-float-label" style="margin-top: 25px;">
                              <input type="text" id="CHEQUENO" formControlName="CHEQUENO" maxlength="6" minlength="6"
                                [ngClass]="{'is-invalid':(c.CHEQUENO.dirty || c.CHEQUENO.touched) && c.CHEQUENO.errors}"
                                class="form-control CommonTextBox TbxMarginBtm" placeholder="&nbsp;"
                                (keypress)="ValidatePattern('Number',$event)" (keyup)="OnChangeInvestedAmount($event)"
                                (paste)="OnPaste($event)" (drop)="OnDrop($event)" />
                              <label for="CHEQUENO">Cheque Number</label>
                              <div *ngIf="(c.CHEQUENO.dirty || c.CHEQUENO.touched) && c.CHEQUENO.errors"
                                class="invalid-feedback">
                                <div *ngIf="c.CHEQUENO.errors.required">Cheque Number is required</div>
                                <!-- <div *ngIf="c.CHEQUENO.errors.invalid">Cheque Number is invalid</div> -->
                                <div *ngIf="c.CHEQUENO.errors.minlength || c.CHEQUENO.errors.maxlength">Cheque Number
                                  must be of 6 digit</div>
                                <!-- <div *ngIf="c.CHEQUENO.errors.max">Cheque Number must be of 6 digit</div> -->
                                <div *ngIf="c.CHEQUENO.errors.pattern">Only number is valid</div>

                              </div>
                              <!-- <div class="invalidBank" *ngIf="showChequeInputError">Cheque Number must be of 6 digits
                              </div> -->
                            </div>

                            <div class="has-float-label" style="margin-top: 25px;">
                              <input type="text" id="chqDate" formControlName="chqDate"
                                class="form-control CommonTextBox TbxMarginBtm clsCommonDatePicker clsDatePickerChequeDate"
                                placeholder="&nbsp;" maxlength="10" (input)="CheckDate($event, 1)"
                                (keypress)="formatDate($event, 1)"
                                [ngClass]="{'is-invalid':(c.chqDate.dirty || c.chqDate.touched) && c.chqDate.errors}" />

                              <label for="chqDate">Cheque Date</label>

                              <div *ngIf="(c.chqDate.dirty || c.chqDate.touched) && c.chqDate.errors"
                                class="invalid-feedback">
                                <div *ngIf="c.chqDate.errors?.required">
                                  Cheque Date is required
                                </div>

                                <div *ngIf="c.chqDate.errors?.invalidDate">
                                  Please enter valid Cheque Date.
                                </div>

                                <div *ngIf="c.chqDate.errors?.invalidRange">
                                  Cheque Date Must be within the last 74 days.
                                </div>
                              </div>
                            </div>

                            <!-- <div>
                              The challan has been sent to your registered Email ID. Kindly issue a cheque from the above mentioned account along with the challan towards payment of your Mutual Fund order in favour of "Indian Clearing Corporation Limited"
                            </div> -->
                            <div class="col-md-4 col-sm-6 col-xs-12 pt-4" style="padding-left: 0 !important;">
                              <button type="button" id="rzp-button1" class="paybutton challanBtn"
                                (click)="SetSelectedPaymentMode('CHEQUE')">Generate Challan</button>
                            </div>
                          </div>
                          <!-- <div class="col-md-4 col-sm-6 col-xs-12 d-flex align-items-center justify-content-end" style="padding-bottom: 160px;">
                            <img *ngIf="!paymentVisibility.CHEQUEMODE" src="../../../assets/images/accordion-down-arrow_Payment.svg"
                            class="showToggleArrow" (click)="SetSelectedPaymentMode('CHEQUEMODE')" />
                          </div> -->
                        </div>
                        <!-- <div class="mt-2 pb-2">
                          <label class="mb-0"><strong>Funds Credit Confirmation at BSE StAR/ICCL</strong></label>
                          <table class="CommonTable" [ngClass]="IsMobile ? 'w-50':''">
                           
                            <thead class="Liner">
                              <th>Credit of funds to BSE is on T+2 till T+5</th>
                            </thead>
                          </table>
                        </div> -->
                      </form>
                    </div>

                  </div>
                </div>
              </div>
              <!-- <div class="modal-footer">
                <button type="button" data-dismiss="modal" class="close" (click)="CloseMainModal()">Cancel</button>
              </div> -->
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- <div class="modal" id="AlertModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="RefreshModalContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer">Okay</button>
      </div>
    </div>
  </div>
</div> -->

<div class="modal mdlCls" id="failBSEAlertModal" appDisabledRightClick data-backdrop='static' data-keyboard='false'>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" routerLink="/dashboard"
          routerLinkActive="active">
          <span inert>&times;</span>
        </button>
      </div>
      <div id="FailBSEAlertModalContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer"> Okay</button>
      </div>
    </div>
  </div>
</div>


<div class="modal mdlCls" id="AlertModalprofilemodels" appDisabledRightClick data-backdrop='static'
  data-keyboard='false'>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="AlertModalContentmodels" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" routerLink="/reports-new/orderbook-report"
          class="CursorPointer">Okay</button>
      </div>
    </div>
  </div>
</div>


<!-- <div class="modal mdlCls" id="ConfirmTransactionmodels" appDisabledRightClick data-backdrop='static'
  data-keyboard='false'>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="ConfirmTransactionContentmodels" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" (click)="paymentModeSelected()" class="CursorPointer">Okay</button>
        <button type="button" data-dismiss="modal" class="CursorPointer">Cancel</button>
      </div>
    </div>
  </div>
</div> -->
<div class="modal overlay mdlCls" id="ConfirmTransactionmodels" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" routerLinkActive="active">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div id="ConfirmTransactionContentmodels" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" (click)="paymentModeSelected()" class="CursorPointer"> Okay </button>
        <button type="button" data-dismiss="modal" class="CursorPointer">Cancel</button>
      </div>
    </div>
  </div>
</div>

<div class="modal mdlCls overlay" id="MoreTransactionmodels" appDisabledRightClick data-backdrop='static'
  data-keyboard='false'>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="MoreTransactionContentmodels" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button [hidden]="Source == 'FromOrderBookReport'" type="button" data-dismiss="modal"
          (click)="goToTransactPage()" class="CursorPointer">Go To Transact Page</button>
        <button type="button" data-dismiss="modal" (click)="goToOrderBook()">{{ShowBTNText}}</button>
      </div>
    </div>
  </div>
</div>
<div class="modal mdlCls overlay" id="MoreTransactionmodelAutoPay" appDisabledRightClick data-backdrop='static'
  data-keyboard='false'>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="MoreTransactionContentmodelAutoPay" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" (click)="goToTransactPage()" class="CursorPointer">Go To Transact
          Page</button>
        <button type="button" data-dismiss="modal" (click)="goToOrderBook()">Go To Order Book</button>
      </div>
    </div>
  </div>
</div>

<div class="modal mdlCls overlay" id="CartLinkSuccess" appDisabledRightClick data-backdrop='static'
  data-keyboard='false'>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="CartLinkSuccessBody" class="modal-body AlertModalBody">
        Orders initiated suceessfully
      </div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" (click)="goToDashboard()" class="CursorPointer">Check Status</button>
      </div>
    </div>
  </div>
</div>

<div class="modal mdlCls overlay" id="CartLinkFailure" appDisabledRightClick data-backdrop='static'
  data-keyboard='false'>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="CartLinkFailureBody" class="modal-body AlertModalBody">
        There was an issue in processing your orders, kindly try again
      </div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" (click)="CloseMainModal()" class="CursorPointer">OK</button>
      </div>
    </div>
  </div>
</div>

<div class="modal mdlCls overlay" id="ChequePaymentFailModeAlertModal" appDisabledRightClick data-backdrop='static'
  data-keyboard='false' [ngClass]="isShowPaymentModel ? 'CheqePaymentFail' : ''">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="ChequePaymentFailModeAlertModalContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <!-- <button type="button" data-dismiss="modal" (click)="RedirectPayment()" class="CursorPointer">OK</button> -->
        <button type="button" data-dismiss="modal" (click)="RedirectBackToPayment()" class="CursorPointer">Okay</button>
      </div>
    </div>
  </div>
</div>


<div class="modal mdlCls overlay" id="VerifyChequeNoModel" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="VerifyChequeNoModelContent" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer" (click)='ClosePopUp()'>Okay</button>
      </div>
    </div>
  </div>
</div>

<div class="modal overlay mdlCls" id="ConfirmTransactmodels" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="ConfirmTransactContentmodels" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" (click)="ProceedNEFTRTGS()" class="CursorPointer"> Okay </button>
        <button type="button" data-dismiss="modal" (click)="ClosePopUp()" class="CursorPointer">Cancel</button>
      </div>
    </div>
  </div>
</div>

<div class="modal mdlCls" id="AlertModalOkmodels" appDisabledRightClick data-backdrop='static' data-keyboard='false'>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="AlertModalOkContentmodels" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" (click)="goToTransactPage()" class="CursorPointer">Okay</button>
      </div>
    </div>
  </div>
</div>


<div class="modal overlay mdlCls" id="ConfirmChallanGenerationmodels" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message
        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          routerLinkActive="active">
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <div id="ConfirmChallanGenerationContentmodels" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" (click)="paymentModeSelected()" class="CursorPointer"> Okay </button>
        <button type="button" data-dismiss="modal" class="CursorPointer">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Background (overlay) -->
<div id="modalOverlay" class="overlay"></div>

<!-- Modal Popup
<div id="myModal" class="modal">
    <div class="modal-content">
        <span class="close-btn" id="closeModalBtn">&times;</span>
        <h2>This is a Modal</h2>
        <p>Some content inside the modal...</p>
    </div>
</div> -->